import type { ApiFetchGameFiltersPort } from '~/handlers/ports/api-fetch-game-filters.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchGameFiltersAdapter
  implements ApiFetchGameFiltersPort
{
  async handle(params: GameFiltersParams): Promise<GameFiltersApiResponse> {
    // Construir query string a partir dos parâmetros
    const queryParams = new URLSearchParams();

    // Adicionar categorias (filtrar "all" e valores vazios)
    if (params.categories && params.categories.length > 0) {
      const validCategories = params.categories.filter(
        (category) => category && category.toLowerCase() !== 'all',
      );

      validCategories.forEach((category) => {
        queryParams.append('categories[]', category);
      });
    }

    // Adicionar providers (filtrar "all" e valores vazios)
    if (params.providers && params.providers.length > 0) {
      const validProviders = params.providers.filter(
        (provider) => provider && provider.toLowerCase() !== 'all',
      );

      validProviders.forEach((provider) => {
        queryParams.append('providers[]', provider);
      });
    }

    // Adicionar termo de busca (trim para remover espaços)
    if (params.term && params.term.trim()) {
      queryParams.append('term', params.term.trim());
    }

    // Adicionar ordenação (apenas se não for vazio)
    if (params.sort && params.sort.trim()) {
      queryParams.append('sort', params.sort.trim());
    }

    // Adicionar tipos de jogo (filtrar valores vazios)
    if (params.types && params.types.length > 0) {
      const validTypes = params.types.filter((type) => type && type.trim());

      validTypes.forEach((type) => {
        queryParams.append('types[]', type);
      });
    }

    // Adicionar sort_by (apenas se não for vazio)
    if (params.sort_by && params.sort_by.trim()) {
      queryParams.append('sort_by', params.sort_by.trim());
    }

    // Adicionar sort_dir (apenas se não for vazio)
    if (params.sort_dir && params.sort_dir.trim()) {
      queryParams.append('sort_dir', params.sort_dir.trim());
    }

    // Adicionar paginação
    queryParams.append('page', String(params.page || 1));
    queryParams.append('per_page', String(params.per_page || 24));

    const queryString = queryParams.toString();
    const url = `${getApostatudoApiUrl()}/games/filter${queryString ? `?${queryString}` : ''}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    const result: GameFiltersApiResponse = await response.json();

    return result;
  }
}
